export default __webpack_public_path__ + "static/media/ribbon.fdf841a7.svg";